
import React, { useState, useRef, useEffect } from 'react';
import 'primeicons/primeicons.css';
import { Route, Routes, useLocation, useSearchParams } from "react-router-dom";
import { config } from "./shared/config";
import * as util from './shared/commons';
import axios from "axios";
import Login from './user/Login';
import ResetPassword from './user/ResetPassword';
import { Sidebar as ProSideBar } from 'react-pro-sidebar';
import { Sidebar } from 'primereact/sidebar';
import { Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Link, Navigate } from 'react-router-dom';
import Home from './user/Home';
import DiscountTypes from './basic tables/DiscountTypes';
import DisorderTypes from './basic tables/DisorderTypes';
import PaymentTypes from './basic tables/PaymentTypes';
import Courses from './basic tables/Course';
import SchoolList from './basic tables/SchoolList';
import SchoolNew from './basic tables/SchoolNew';
import SchoolSetActive from './basic tables/SchoolSetActive';
import SystemPrice from './basic tables/SystemPrice';
import SchoolSetDebt from './basic tables/SchoolSetDebt';
import SchoolSetMaxStudent from './basic tables/SchoolSetMaxStudent';
import SchoolSetSmschargeRemain from './basic tables/SchoolSetSmschargeRemain';
import SchoolSetExpireDate from './basic tables/SchoolSetExpireDate';
import RequestMembership from './user/RequestMembership';
import SchoolPayment from './payment/SchoolPayment';
import SchoolPaymentCheque from './payment/SchoolPaymentCheque';
import SchoolManagerSetPassword from './basic tables/SchoolManagerSetPassword';
import Fields from './basic tables/Fields';
import MemberShipRequestList from './basic tables/MemberShipRequestList';
import PublicRequestMembership from './user/PublicRequestMembership';
import SchoolDeptorList from './basic tables/SchoolBill';
import SchoolClass from './school/SchoolClass';
import SchoolStudents from './school/SchoolStudents';
import SchoolUser from './school/SchoolUser';
import StudentSelector from './school/StudentSelector';
import SetClassStudent from './school/SetClassStudent';
import SchoolTiming from './school/SchoolTiming';
import SchoolSetManager from './basic tables/SchoolSetManager';
import SchoolDisOrderTypes from './school/SchoolDisOrderTypes';
import { InputText } from 'primereact/inputtext';
import FaDate from './shared/FaDate';
import SchoolAbsentPresent from './school/SchoolAbsentPresent';
import TeacherAbsentPresent from './school/TeacherAbsentPresent';
import TeacherTiming from './school/TeacherTiming';
import TeacherExams from './school/TeacherExams';
import SchoolAutoTiming from './school/SchoolAutoTiming';
import PrintTimeing from './school/PrintTimeing';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Container, Row } from 'react-bootstrap';
import TeacherFinalScores from './school/TeacherFinalScores';
import SchoolDisiplineNotebook from './school/SchoolDisiplineNotebook';
import SchoolDisiplineScores from './school/SchoolDisiplineScores';
import SchoolTimingReplace from './school/SchoolTimingReplace';
import SelectRole from './user/SelectRole';
import SmsApiKeys from './basic tables/SmsApiKeys';
import SendSmsByGroup from './message/SendSmsByGroup';
import SendSms from './message/SendSms';
import SmsCharge from './message/SmsCharge';
import SchoolGradeSheetPrint from './school/SchoolGradeSheetPrint';
import SchoolGradeSheetCreate from './school/SchoolGradeSheetCreate';
import AnnounceSimple from './school/AnnounceSimple';
import ShowAnnounceSimple from './message/ShowAnnounceSimple';
import AgentRequestMembership from './user/AgentRequestMembership';
import AgentMemberShipRequestList from './basic tables/AgentMemberShipRequestList';
import AgentList from './basic tables/AgentList';
import SetAdminSmsApiKey from './basic tables/SetAdminSmsApiKey';
import Default from './user/Default';
import StudentTiming from './student/StudentTiming';
import StudentScores from './student/StudentScores';
import StudentDisorders from './student/StudentDisorders';
import ChangePassword from './user/ChangePassword';
import TeacherNotes from './school/TeacherNotes';
import SchoolAnalyticChart from './school/SchoolAnalyticChart';
import SchoolMobileSmses from './school/SchoolMobileSmses';
import AbsentSummaryReport from './school/AbsentSummaryReport';
import SidaGetToken from './school/SidaGetToken';
import DownloadSmsSenderApk from './shared/DownloadSmsSenderApk';
import TeacherHistoryPresentAbsent from './school/TeacherHistoryPresentAbsent';
import SidaExtenssion from './shared/SidaExtenssion';
import AdminSpecialOperations from './basic tables/AdminSpecialOperations';
import SetGradeSheetVisibility from './school/SetGradeSheetVisibility';
import StudentGradeSheet from './student/StudentGradeSheet';
import SchoolParameters from './school/SchoolParameters';
import PrintDisiplineSheet from './school/PrintDisiplineSheet';
import TeacherScores from './school/TeacherScores';
import EmployeeInMandatoryHours from './school/EmployeeInMandatoryHours';
import EmployeeInMandatoryHoursReport from './school/EmployeeInMandatoryHoursReport';
import EmployeeAbsentHours from './school/EmployeeAbsentHours';
import EmployeeAbsentHoursReport from './school/EmployeeAbsentHoursReport';

function App(props) {
  const location = useLocation();
  const [accountChanged, setAccountChanged] = useState(0);
  const [sideBarVisible, setSideBarVisible] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");
  const ref = useRef();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    var found = false;
    if (location.pathname == "/") {
      if (searchParams.get("agentCode")) {
        var agentCode = searchParams.get("agentCode");
        if (util.IsIntNumber(agentCode)) {
          var ac = parseInt(agentCode);
          if (ac >= 100) {
            util.setAgentCode(ac);
            found = true;
          }
        }
      }
      if (!found) {
        var agentCode = searchParams.get("ac");
        if (util.IsIntNumber(agentCode)) {
          var ac = parseInt(agentCode);
          if (ac >= 100) {
            util.setAgentCode(ac);
            found = true;
          }
        }

      }
    }

    console.log("AgentCode is>", util.getAgentCode());
  }, []);

  const IsLogedIn = function () {
    if (util.isLogedIn()) return true;
    var user = util.getCurrentUser();
    console.log("user in IsLoged in is>", user)
    if (user.Role <= 0) return false;
    if (user.UserId === "") {
      return false;
    }
    else {
      var params = { UserId: user.UserId, Token: user.Token };
      var url = config.Server + `/user/login-by-token`;
      axios
        .post(url, params)
        .then(res => {
          var response = res.data;
          if (response.status === "ok") {

            response = response.data;
            util.setCurrentUser(user);
            return true;
          }
          else {
            return false;
          }
        })
        .catch(error => {
          return false;
        });

    }
    return false;
  }
  const checkCallFromSoftware = function (qstring) {
    let queryParams = [];
    // remove first letter from query string
    qstring = qstring.substring(1);
    // console.log("string", string);
    // convert string to array
    const queryParamsArray = qstring.split("&");
    // console.log("queryParamsArray", queryParamsArray);

    // covert each index query to object
    queryParamsArray.forEach((queryParam) => {
      // console.log("queryParam", queryParam);
      // split param by =
      const queryParamArray = queryParam.split("=");
      // console.log("queryParamArray", queryParamArray);
      queryParams.push({ "name": queryParamArray[0], "value": queryParamArray[1] });
      // console.log("queryParams", queryParams);
    });
    let isSoftware = false;
    if (queryParams.length >= 3) {
      if ((queryParams[0].name === "page") && (queryParams[1].name === "UserId") && (queryParams[2].name === "Token")) isSoftware = true;
    }
    return { isSoftware: isSoftware, params: queryParams };
  };
  let queryParams = checkCallFromSoftware(location.search);

  const customIcons = (
    <React.Fragment>
      <button className="p-sidebar-icon p-link mr-2">
      </button>
    </React.Fragment>
  );
  const toolbarStartContent = function () {
    if ((window.location.pathname == "/home") || (window.location.pathname == "")) {
      return (
        <React.Fragment>
          <Button icon="pi pi-bars" className="mr-2" onClick={() => setSideBarVisible(true)} />
        </React.Fragment>
      )
    }
    else {
      return (
        <React.Fragment>
          <Button icon="pi pi-bars" className="mr-2" onClick={() => setSideBarVisible(true)} />
          <Button icon="pi pi-home" className="mr-2" onClick={() => { document.location = "/home";/*setRedirectUrl("/home")*/ }} style={{ marginRight: "10px" }} />
        </React.Fragment>
      )
    }
  }
  const toolbarCenterContent = function () {
    var user = util.getCurrentUser();
    if (user.Role === 1) {
      return (
        <div style={{ color: "#FFF", fontSize: "12pt" }}>داشبورد کلاسیکو 7<br />مدیریت</div>
      )
    }
    else if (user.Role === 7) {
      return (
        <div style={{ color: "#FFF", fontSize: "12pt" }}>داشبورد کلاسیکو 7<br />نماینده فروش</div>
      )
    }
    else {
      for (var i = 0; i < user.SelectableRoles.length; i++) {
        if ((user.Role == user.SelectableRoles[i].role.id) && (user.SchoolId == user.SelectableRoles[i].school.id)) {
          return (
            <div style={{ color: "#FFF", fontSize: "12pt", maxWidth:"calc(100% - 10px)" }} className="d-inline-block text-nowrap text-truncate">داشبورد کلاسیکو 7<br />{util.getSchoolName()}</div>
          )
        }
      }
      return (
        <div style={{ color: "#FFF", fontSize: "12pt" }}>داشبورد کلاسیکو 7</div>
      )
    }
  }
  const toolbarEndContent = (
    <></>
  );
  const customHeader = function () {
    var user = util.getCurrentUser();
    var mnu = "منو";
    if (user.Role == util.UserRoles.Admin) mnu = "ادمین سیستم"
    else if (user.Role == util.UserRoles.Manager) mnu = "مدیر مدرسه"
    else if (user.Role == util.UserRoles.Assistant) mnu = "معاون مدرسه"
    else if (user.Role == util.UserRoles.Teacher) mnu = "معلم"
    else if (user.Role == util.UserRoles.Student) mnu = "دانش آموز"
    else if (user.Role == util.UserRoles.Parent) mnu = "ولی دانش آموز"
    return (
      <div className="flex align-items-center gap-2">
        <span className="font-bold">{mnu}</span>
        <br />
        {user.Firstname + " " + user.Lastname}
      </div>
    );
  }
  const showMenus = function () {
    var user = util.getCurrentUser();
    if (user.Role === 1) {
      return (
        <Sidebar header={customHeader} visible={sideBarVisible} onHide={() => setSideBarVisible(false)} icons={customIcons}>
          <ProSideBar>
            <Menu>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/new" />}> ثبت مدرسه جدید </MenuItem>
              <SubMenu label="عملیات مدارس">
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/list" />}> لیست مدارس </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/set-active" />}> ثبت وضعیت مدرسه </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/set-expire-date" />}> تنظیم تاریخ انقضای </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/set-max-student" />}> تنظیم حداکثر تعداد دانش آموز </MenuItem>
                {/* <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/set-sms-charge-remain" />}> تنظیم مانده شارژ پیامکی </MenuItem> */}
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/user/manager/set-password" />}> تغیر رمز مدیر مدرسه </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/manager/set" />}> تغیر مدیر مدرسه </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/membership/request/list" />}> بررسی درخواست عضویت مدرسه</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/admin/special/operations" />}>عملیات های ویژه ادمین</MenuItem>

              </SubMenu>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/agent/membership/request/list" />}> درخواست های نمایندگی </MenuItem>
              <SubMenu label="عملیات مالی">
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/set-debt" />}> تنظیم بدهی و تخفیف </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/payment/list" />}> پرداخت های مدرسه </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/payment/cheque/list" />}> چک های های مدرسه </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/system/price" />}>قیمت های نرم افزار</MenuItem>
              </SubMenu>
              <SubMenu label="گزارشات">
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/debtor/list" />}> لیست مدارس بدهکار </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/bill/view" />}> مشاهده صورتحساب مدرسه </MenuItem>
              </SubMenu>
              <SubMenu label="جداول پایه">
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/users/agent/list" />}> لیست نماینده ها </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/basics/disorder-types" />}> انواع رفتار </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/basics/discount-types" />}> انواع تخفیف </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/basics/payment-types" />}> انواع شهریه </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/basics/fields" />}> لیست رشته ها </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/basics/courses" />}> لیست دروس </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/basic/admin/set/sms-api-key" />}> کلید پیامک ادمین </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/basics/sms-api-keys" />}> کلیدهای ارسال پیامک </MenuItem>
              </SubMenu>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/change-password" />}> تغیر کلمه عبور </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); util.clearCurrentUser(); }} component={<Link to="/login" />}> خروج </MenuItem>
            </Menu>
          </ProSideBar>
        </Sidebar>
      );
    }
    else if (user.Role === 2 || user.Role === 3) {
      return (
        <Sidebar header={customHeader} visible={sideBarVisible} onHide={() => setSideBarVisible(false)} icons={customIcons}>
          <ProSideBar>
            <Menu>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/timing" />}>برنامه هفتگی</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/present-absent" />}>حضور و غیاب</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/disiplin-notebook" />}>دفتر انضباط</MenuItem>
              <SubMenu label="پیام">
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/send-sms/classes" />}>ارسال گروهی پیامک</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/send-sms/single" />}>ارسال پیامک</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/mobile-smses/list" />}>پیامک های آماده ارسال</MenuItem>
                {/* <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/sms/charge" />}>شارژ پیامک</MenuItem> */}
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/announce-simple" />}>اطلاعیه</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/sms-sender/download" />}>دانلود اپلیکیشن پیامک</MenuItem>
              </SubMenu>
              <SubMenu label="کارنامه">
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/disipline-scores" />}>ثبت انضباط ماهانه</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/grade-sheet/create" />}>ایجاد کارنامه ها</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/grade-sheet/print" />}>چاپ کارنامه</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/analytic-chart" />}>نمودار های تحلیلی</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/absent-student/report" />}>گزارش غیبت</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/grade-sheet/visibility/set" />}>تنظیم مشاهده کارنامه</MenuItem>
              </SubMenu>
              <SubMenu label="عملیات همکاران">
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/user" />}>لیست همکاران</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/employee/in-mandatory-hours" />}>غیر موظف همکاران</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/employee/absent-hours" />}>ثبت غیبت همکاران</MenuItem>
              </SubMenu>
              <SubMenu label="جداول پایه">
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/class" />}>کلاس های مدرسه</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/student" />}>دانش آموزان</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/class/student" />}>کلاس بندی دانش آموزان</MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/setting/disorder-types" />}> انواع رفتار </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/sida/token/get" />}> دریافت کلید سیدا </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/sida/extenssion" />}> افزونه سیدا </MenuItem>
                <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/setting" />}> تنطیمات </MenuItem>
              </SubMenu>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/change-password" />}> تغیر کلمه عبور </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); util.clearCurrentUser(); }} component={<Link to="/login" />}> خروج </MenuItem>
            </Menu>
          </ProSideBar>
        </Sidebar>

      );
    }
    else if (user.Role === 4) {
      return (
        <Sidebar header={customHeader} visible={sideBarVisible} onHide={() => setSideBarVisible(false)} icons={customIcons}>
          <ProSideBar>
            <Menu>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/teacher/timing" />}>برنامه کلاسی</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/teacher/present-absent" />}>ثبت حضور و غیاب</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/teacher/scores" />}>نمرات</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/teacher/notes" />}>یادداشت های کلاسی</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/message/announce-simple" />}>اطلاعیه</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/teacher/history/present-absent" />}>تاریخچه حضور و غیاب</MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/change-password" />}> تغیر کلمه عبور </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); util.clearCurrentUser(); }} component={<Link to="/login" />}> خروج </MenuItem>
            </Menu>
          </ProSideBar>
        </Sidebar>

      );
    }
    else if ((user.Role === 5) || (user.Role === 6)) {
      return (
        <Sidebar header={customHeader} visible={sideBarVisible} onHide={() => setSideBarVisible(false)} icons={customIcons}>
          <ProSideBar>
            <Menu>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/student/timing" />}>برنامه کلاسی</MenuItem>
               <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/student/grade-sheet/disorder" />}>کارنامه تربیتی</MenuItem>
              {/*<MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/student/grade-sheet/continual" />}>کارنامه مستمر</MenuItem>*/}
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/student/scores" />}>نمرات آزمون ها</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/student/grade-sheet/print" />}>چاپ کارنامه</MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/message/announce-simple" />}>اطلاعیه</MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/change-password" />}> تغیر کلمه عبور </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); util.clearCurrentUser(); }} component={<Link to="/login" />}> خروج </MenuItem>
            </Menu>
          </ProSideBar>
        </Sidebar>

      );
    }
    else if (user.Role === 7) {
      return (
        <Sidebar header={customHeader} visible={sideBarVisible} onHide={() => setSideBarVisible(false)} icons={customIcons}>
          <ProSideBar>
            <Menu>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/list" />}> لیست مدارس </MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/school/set-active" />}> ثبت وضعیت مدرسه </MenuItem>
              <MenuItem onClick={() => setSideBarVisible(false)} component={<Link to="/membership/request/list" />}> بررسی درخواست عضویت مدرسه</MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); }} component={<Link to="/change-password" />}> تغیر کلمه عبور </MenuItem>
              <MenuItem onClick={() => { setSideBarVisible(false); util.clearCurrentUser(); }} component={<Link to="/login" />}> خروج </MenuItem>
            </Menu>
          </ProSideBar>
        </Sidebar>

      );
    }
  }
  return (
    (redirectUrl != "")
      ?
      <Navigate to={redirectUrl} replace={false} />
      :
      IsLogedIn() ?
        <>
          <Container fluid>
            <Row style={{zIndex:"1000", position: "fixed", top: "0px", left: "0px", width: "calc(100% - 0px)", backgroundColor:"var(--indigo-600)", margin:"0px", paddingTop:"10px"}}>
              <Col xs={4} style={{maxWidth:"115px"}}>
                {toolbarStartContent()}
              </Col>
              <Col xs={8}>
                {toolbarCenterContent()}
              </Col>
            </Row>
            {showMenus()}
            <div className="content" style={{ marginTop: "90px", paddingBottom: "200px" }}>
              <Routes>
                <Route path="/school/sida/token/get" Component={SidaGetToken} />
                <Route path="/basics/discount-types" Component={DiscountTypes} />
                <Route path="/basics/disorder-types" Component={DisorderTypes} />
                <Route path="/basics/fields" Component={Fields} />
                <Route path="/basics/Payment-types" Component={PaymentTypes} />
                <Route path="/basics/courses" Component={Courses} />
                <Route path="/basics/sms-api-keys" Component={SmsApiKeys} />
                <Route path="/school/list" Component={SchoolList} />
                <Route path="/school/new" Component={SchoolNew} />
                <Route path="/school/set-active" Component={SchoolSetActive} />
                <Route path="/system/price" Component={SystemPrice} />
                <Route path="/school/set-debt" Component={SchoolSetDebt} />
                <Route path="/school/set-max-student" Component={SchoolSetMaxStudent} />
                <Route path="/school/set-sms-charge-remain" Component={SchoolSetSmschargeRemain} />
                <Route path="/school/set-expire-date" Component={SchoolSetExpireDate} />
                <Route path="/school/payment/list" Component={SchoolPayment} />
                <Route path="/school/payment/cheque/list" Component={SchoolPaymentCheque} />
                <Route path="/user/manager/set-password" Component={SchoolManagerSetPassword} />
                <Route path="/school/manager/set" Component={SchoolSetManager} />
                <Route path="/membership/request/list" Component={MemberShipRequestList} />
                <Route path="/school/bill/view" Component={SchoolDeptorList} />
                <Route path="/school/class" Component={SchoolClass} />
                <Route path="/school/student" Component={SchoolStudents} />
                <Route path="/school/user" Component={SchoolUser} />
                <Route path="/school/employee/in-mandatory-hours/report" Component={EmployeeInMandatoryHoursReport} />
                <Route path="/school/employee/in-mandatory-hours" Component={EmployeeInMandatoryHours} />
                <Route path="/school/employee/absent-hours/report" Component={EmployeeAbsentHoursReport} />
                <Route path="/school/employee/absent-hours" Component={EmployeeAbsentHours} />
                <Route path="/school/class/student" Component={SetClassStudent} />
                <Route path="/school/print-timing" Component={PrintTimeing} />
                <Route path="/school/timing" Component={SchoolTiming} />
                <Route path="/school/auto-timing" Component={SchoolAutoTiming} />
                <Route path="/school/timing/replace/teacher" Component={SchoolTimingReplace} />
                <Route path="/school/present-absent" Component={SchoolAbsentPresent} />
                <Route path="/school/setting/disorder-types" Component={SchoolDisOrderTypes} />
                <Route path="/school/disiplin-notebook" Component={SchoolDisiplineNotebook} />
                <Route path="/teacher/timing" Component={TeacherTiming} />
                <Route path="/teacher/present-absent" Component={TeacherAbsentPresent} />
                <Route path="/teacher/scores" Component={TeacherScores} />
                <Route path="/teacher/exams" Component={TeacherExams} />
                <Route path="/teacher/final-scores" Component={TeacherFinalScores} />
                <Route path="/teacher/notes" Component={TeacherNotes} />
                <Route path="/school/disipline-scores" Component={SchoolDisiplineScores} />
                <Route path="/school/send-sms/classes" Component={SendSmsByGroup} />
                <Route path="/school/send-sms/single" Component={SendSms} />
                <Route path="/school/sms/charge" Component={SmsCharge} />
                <Route path="/school/disipline/grade-sheet/print" Component={PrintDisiplineSheet} />
                <Route path="/school/grade-sheet/create" Component={SchoolGradeSheetCreate} />
                <Route path="/school/grade-sheet/print" Component={SchoolGradeSheetPrint} />
                <Route path="/school/announce-simple" Component={AnnounceSimple} />
                <Route path="/message/announce-simple" element={<ShowAnnounceSimple onlyShowNew={false} />} />
                <Route path="/agent/membership/request/list" Component={AgentMemberShipRequestList} />
                <Route path="/users/agent/list" Component={AgentList} />
                <Route path="/basic/admin/set/sms-api-key" Component={SetAdminSmsApiKey} />
                <Route path="/student/timing" Component={StudentTiming} />
                <Route path="/student/scores" Component={StudentScores} />
                <Route path="/student/grade-sheet/print" Component={StudentGradeSheet} />
                <Route path="/student/grade-sheet/disorder" Component={StudentDisorders} />
                <Route path="/change-password" Component={ChangePassword} />
                <Route path="/school/analytic-chart" Component={SchoolAnalyticChart} />
                <Route path="/school/mobile-smses/list" Component={SchoolMobileSmses} />
                <Route path="/school/absent-student/report" Component={AbsentSummaryReport} />
                <Route path="/sms-sender/download" Component={DownloadSmsSenderApk} />
                <Route path="/teacher/history/present-absent" Component={TeacherHistoryPresentAbsent} />
                <Route path="/sida/extenssion" Component={SidaExtenssion} />
                <Route path="/school/setting" Component={SchoolParameters} />
                <Route path="/admin/special/operations" Component={AdminSpecialOperations} />
                <Route path="/school/grade-sheet/visibility/set" Component={SetGradeSheetVisibility} />

                <Route path="*" Component={Home} />
              </Routes>
            </div>
          </Container>
        </>
        :
        <>
          <Container fluid style={{ overflowX: "hidden" }}>
            <div className="login-full-page justify-content-center">
              <Row>
                {
                  ((location.pathname == "/login") || (location.pathname == "/select-role") || (location.pathname == "/reset-password")) ?
                    <>
                      <Col md={4}>
                        <Routes>
                          <Route path="/login" Component={() => (<Login onAccountChanged={() => { setAccountChanged(accountChanged + 1) }} />)} />
                          <Route path="/select-role" Component={() => (<SelectRole onAccountChanged={() => { setAccountChanged(accountChanged + 1) }} />)} />
                          <Route path="/reset-password" Component={() => (<ResetPassword onAccountChanged={() => { setAccountChanged(accountChanged + 1) }} />)} />
                          <Route path="/default" Component={Default} />
                          <Route path="*" Component={Default} />
                        </Routes>
                      </Col>
                      <Col md={8}>
                        <img src={require("./../src/lib/images/login_right.jpg")} width="100%" height="100%" />
                      </Col>
                    </>
                    :
                    ((location.pathname == "/default") || (location.pathname == "/index") || (location.pathname == "/")) ?
                      <>
                        <Col md={12}>
                          <Routes>
                            <Route path="*" Component={Default} />
                          </Routes>
                        </Col>
                      </>

                      :
                      <Col md={12}>
                        <Routes>
                          <Route path="/request-membership" Component={RequestMembership} />
                          <Route path="/agent/request/membership" Component={AgentRequestMembership} />
                          <Route path="/public/request-membership" Component={PublicRequestMembership} />
                        </Routes>
                      </Col>
                }
              </Row>
            </div>
          </Container>
        </>
  );
}

export default App;
